module.exports = __webpack_public_path__ + "static/img/5.c1f599d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/5.png
// module id = oitg
// module chunks = 0